import React from 'react'
import { useUser } from '@paintscout/ui'
import type { Permission } from 'paintscout'

export interface RoleProps {
  permission?: Permission
  roles?: string[]
  children: JSX.Element
}

/**
 * Only renders the children if the user has the required permission
 */
export default function Role({ children, permission, roles = [], ...other }: RoleProps): JSX.Element {
  const { profile, hasPermissions } = useUser()
  if (profile) {
    const hasPermissionAccess = hasPermissions([permission]) || !permission
    const hasRoleAccess = roles.length ? profile.roles.some((role) => roles.includes(role)) : true
    const hasAccess = hasPermissionAccess && hasRoleAccess

    return (
      hasAccess
        ? Array.isArray(children)
          ? React.Children.map(children, (child) => React.cloneElement(child, other || {}))
          : React.cloneElement(children, other || {})
        : null
    ) as JSX.Element
  }

  return null
}
